<template>
  <v-container fluid grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs12 mb-2 v-if="getFiltersChips">
        <Filters v-bind:filters="getFilters"></Filters>
      </v-flex>
      <v-flex offset-xs1 xs10>
        <v-toolbar>
          <v-overflow-btn v-model="interval" @input="changeInterval()" item-text="item.text" item-value="item.value" :items="timeInterval" label="Select time interval" hide-details class="pa-0" overflow>
            <template slot="selection" slot-scope="{ item }">
              <span>
                {{item.text}}
              </span>
            </template>
            <template slot="item" slot-scope="{ item }">
              <v-list-tile-content>
                <v-list-tile-title v-text="item.text"></v-list-tile-title>
              </v-list-tile-content>
            </template>
          </v-overflow-btn>
          <v-flex xs12 sm5>
            <v-select dense class="xs-2" width="600px" multiple v-model="selectedConnections" @input="changeInterval()" :items="connections" label="Select connection type" hide-details>
              <template slot="selection" slot-scope="{ item, index }">
                <v-chip small v-if="index === 0">
                  <span>{{ item.text }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text caption">(+{{ selectedConnections.length - 1 }} others)</span>
              </template>
            </v-select>
          </v-flex>
          <v-divider class="mx-2" vertical></v-divider>
          <v-btn-toggle v-model="objectsExplored" class="transparent" multiple @change="toggleObjects()">
            <v-btn value="tweet" flat>
              <v-icon>fab fa-twitter</v-icon>
            </v-btn>
            <v-btn value="article" flat>
              <v-icon>fas fa-newspaper</v-icon>
            </v-btn>
            <v-btn value="hashtag" flat>
              <v-icon>fas fa-hashtag</v-icon>
            </v-btn>
            <v-btn value="entity" flat>
              <v-icon>fas fa-tags</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-toolbar>
        <v-card class="mt-5" height="148px" v-if="initialTweetId === null && $route.query.id === undefined || (!(objectsExplored.indexOf('tweet') !== -1) && !(objectsExplored.indexOf('article') !== -1) && !(objectsExplored.indexOf('hashtag') !== -1) && !(objectsExplored.indexOf('entity') !== -1))">
          <v-layout row align-center justify-space-around>
            <v-flex xs12 order-lg2>
              <div class="d-flex py-4" style="flex-direction: column; align-items: center"><v-icon class="primary--text" style="font-size: 40px !important;width:100%">info</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">No data to backtrack. Click <v-icon small>fas fa-backward</v-icon> from any page, or modify backtrack settings to start.</p></div>
            </v-flex>
          </v-layout>
        </v-card>
        <v-timeline v-else>
          <v-btn @click="prependDates()" :loading="prependLoading === 'loading'" fab :disabled="(prependLoading === 'loading') || !(dates !== 'undefined' && dates.length > 0 && new Date(dates[0].date.fromDate) > new Date(new Date(this.getFilters.fromDate).setHours(0)))">
            <v-tooltip left>
              <span>Backtrack</span>
              <v-icon slot="activator">fas fa-angle-up</v-icon>
            </v-tooltip>
          </v-btn>
          <v-scroll-y-transition group>
            <v-timeline-item v-show="hideNoData(date, index)" :left="timelineItemPosition(index)" :right="!timelineItemPosition(index)" v-for="(date, index) in dates" :key="date.id">
              <span slot="opposite" :class="`font-weight-medium title`" v-text="intervalText(date.date.fromDate, date.date.toDate)"></span>
              <v-card key="tweet" v-if="(date.tweets != undefined && date.tweets.length > 0 && objectsExplored.indexOf('tweet') !== -1)" >
                <v-flex :class="date.tweetDataState !== 'ready' ? 'blurClass' : ''">
                  <v-card-title class="py-0">
                    <v-icon class="px-3">fab fa-twitter</v-icon>
                    <span class="subheading px-2"> {{ formatNumber(date.tweetCountTweets) }} Tweets </span>
                    <v-spacer></v-spacer>
                    <v-flex xs4>
                      <v-select v-model="date.tweetSortBy" @input="sortTweet(index)" :items="sortTweets" single-line hint="Sort by" persistent-hint item-text="text" item-value="value" dense label="Sort by" :menu-props="{maxHeight:'900'}">
                        <template slot="selection" slot-scope="{ item }">
                          <span>
                            {{item.text}}
                          </span>
                        </template>
                        <template slot="item" slot-scope="{ item }">
                          <v-list-tile-content>
                            <v-list-tile-title v-text="item.text"></v-list-tile-title>
                          </v-list-tile-content>
                        </template>
                      </v-select>
                    </v-flex>
                    <v-btn icon @click="date.tweet=!date.tweet" :disabled="(date.page.tweetLastPage === true && date.page.tweetPage === 1 && date.tweets.length === 1)">
                      <v-icon>{{!date.tweet ? 'fas fa-angle-down' : 'fas fa-angle-up'}}</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-list two-lines class="scroll-y list-complete-enter" style="max-height: 400px;">
                    <v-list-tile avatar class="pa-0" @click="goToTweet(date.tweets[0]._twitter_id, date.tweets[0]._user_screen_name)">
                      <v-list-tile-avatar class="pointer" style="margin-top: auto; margin-bottom: auto">
                        <img :src="date.tweets[0]._user_profile_image_url_https" @error="alternateImg(index, 0)">
                      </v-list-tile-avatar>
                      <v-list-tile-content style="width: calc(100% - 60px);" class="pr-4 tweets">
                        <v-list-tile-title v-html="date.tweets[0]._user_name" class="pointer"></v-list-tile-title>
                        <v-list-tile-title v-html="'@'+ date.tweets[0]._user_screen_name" class="pointer caption"></v-list-tile-title>
                        <v-list-tile-sub-title style="max-height:60px" class="pointer">{{ date.tweets[0]._text }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-avatar size="40" class="pointer pr-2">
                        <v-layout row class="align-center pointer accent--text caption">
                          <v-icon size="14" color="green lighten-2">fas fa-retweet</v-icon><br>
                          <span width="100%">{{ formatNumber(date.tweets[0]._retweet_count) }}</span>
                        </v-layout>
                      </v-list-tile-avatar>
                      <v-list-tile-content class='counters align-center'>
                        <v-layout row class="align-center justify-content-center">
                          <v-flex width="66px">
                            <v-list-tile-sub-title>{{ formatEchartsDate(getLocalDate(date.tweets[0]._created_at)) }}</v-list-tile-sub-title>
                            <v-list-tile-sub-title v-html="formatTime(getLocalDate(date.tweets[0]._created_at))"></v-list-tile-sub-title>
                          </v-flex>
                        </v-layout>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-expand-transition group v-if="date.tweet">
                      <v-list>
                        <v-list-tile v-for="(tweet, i) in date.tweets.slice(1)" avatar @click="goToTweet(tweet._twitter_id, tweet._user_screen_name)" :key="tweet._tweet_id" class="py-1 my-1">
                          <v-list-tile-avatar @click="goToUser(tweet._user_screen_name)" class="pointer">
                            <img :src="tweet._user_profile_image_url_https" @error="alternateImg(index, i + 1)">
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title v-html="tweet._user_name" @click="goToUser(tweet._user_screen_name)"  class="pointer"></v-list-tile-title>
                            <v-list-tile-title v-html="'@'+ tweet._user_screen_name" @click="goToUser(tweet._user_screen_name)" class="pointer caption"></v-list-tile-title>
                            <v-list-tile-sub-title v-html="tweet._text" @click="goToTweet(tweet._twitter_id, tweet._user_screen_name)" class="pointer"></v-list-tile-sub-title>
                          </v-list-tile-content>
                          <v-list-tile-avatar size="40" class="pointer pr-2">
                            <v-layout row class="align-center pointer accent--text caption">
                              <v-icon size="14" color="green lighten-2">fas fa-retweet</v-icon><br>
                              <span width="100%">{{ formatNumber(tweet._retweet_count) }}</span>
                            </v-layout>
                          </v-list-tile-avatar>
                          <v-list-tile-content class='counters align-center'>
                            <v-layout row class="align-center justify-content-center">
                              <v-flex width="66px">
                                <v-list-tile-sub-title>{{ formatEchartsDate(getLocalDate(tweet._created_at)) }}</v-list-tile-sub-title>
                                <v-list-tile-sub-title v-html="formatTime(getLocalDate(tweet._created_at))"></v-list-tile-sub-title>
                              </v-flex>
                            </v-layout>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="!(date.page.tweetLastPage === true && date.page.tweetPage === 1)">
                          <v-flex xs12>
                            <v-btn style="position: absolute; left: 5px;" outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToTweetPage('first', index)" :disabled="date.page.tweetPage === 1">
                              <v-icon>first_page</v-icon>
                            </v-btn>
                            <v-btn outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToTweetPage('previous', index)" :disabled="date.page.tweetPage === 1">
                              <v-icon>keyboard_arrow_left</v-icon>
                            </v-btn>
                            <v-btn class="elevation-1 noHover" style="cursor: auto" outline fab dark small color="accent lighten-2">
                              <span style="color: #727272">{{ date.page.tweetPage }}</span>
                            </v-btn>
                            <v-btn class="elevation-1" outline fab dark small color="accent lighten-2" @click="goToTweetPage('next', index)" :disabled="date.page.tweetLastPage">
                              <v-icon>keyboard_arrow_right</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-list-tile>
                      </v-list>
                    </v-expand-transition>
                  </v-list>
                </v-flex>
                <template v-if="date.tweetDataState !== 'ready'">
                  <center class="alternateState">
                    <v-progress-circular
                      :size="70"
                      :width="7"
                      color="primary"
                      indeterminate
                    ></v-progress-circular>
                  </center>
                </template>
              </v-card>
              <v-card key="article" class="my-2" v-if="(date.articles != undefined && date.articles.length > 0 && objectsExplored.indexOf('article') !== -1)" >
                <v-flex :class="date.articleDataState !== 'ready' ? 'blurClass' : ''">
                  <v-card-title class="py-0">
                    <v-icon class="px-3">fas fa-newspaper</v-icon>
                    <span class="subheading px-2"> {{ formatNumber(date.articleCountArticles) }} Articles </span>
                    <v-spacer></v-spacer>
                    <v-flex xs4>
                      <v-select v-model="date.articleSortBy" @input="sortArticle(index)" :items="sortArticles" single-line hint="Sort by" persistent-hint item-text="text" item-value="value" dense label="Sort by" :menu-props="{maxHeight:'900'}">
                        <template slot="selection" slot-scope="{ item }">
                          <span> {{item.text}} </span>
                        </template>
                        <template slot="item" slot-scope="{ item }">
                          <v-list-tile-content>
                            <v-list-tile-title v-text="item.text"></v-list-tile-title>
                          </v-list-tile-content>
                        </template>
                      </v-select>
                    </v-flex>
                    <v-btn icon @click="date.article=!date.article" :disabled="(date.page.articleLastPage === true && date.page.articlePage === 1 && date.articles.length === 1)">
                      <v-icon>{{!date.article ? 'fas fa-angle-down' : 'fas fa-angle-up'}}</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-list two-lines class="scroll-y list-complete-enter" style="max-height: 400px;">
                    <v-list-tile avatar class="pa-0" @click="goToArticle(date.articles[0]._url)">
                      <v-list-tile-avatar color="grey" tile>
                        <img v-if="date.articles[0]._image_url" :src="date.articles[0]._image_url">
                        <v-icon v-else dark>block</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ date.articles[0]._title }}</v-list-tile-title>
                        <v-list-tile-title v-html="date.articles[0]._source" class="pointer caption"></v-list-tile-title>
                        <v-list-tile-sub-title
                          v-html="date.articles[0]._description"
                        ></v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-avatar size="40" class="pointer pr-2">
                        <v-layout row class="align-center pointer accent--text caption">
                          <v-icon size="14" color="blue lighten-2">fab fa-twitter</v-icon><br>
                          <span width="100%">{{ formatNumber(date.articles[0]._tweeted_count) }}</span>
                        </v-layout>
                      </v-list-tile-avatar>
                      <v-list-tile-content class='counters align-center'>
                        <v-layout row class="align-center justify-content-center">
                          <v-flex width="66px">
                            <v-list-tile-sub-title>{{ formatEchartsDate(getLocalDate(date.articles[0]._date_published)) }}</v-list-tile-sub-title>
                            <v-list-tile-sub-title v-html="formatTime(getLocalDate(date.articles[0]._date_published))"></v-list-tile-sub-title>
                          </v-flex>
                        </v-layout>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-expand-transition group v-if="date.article">
                      <v-list>
                        <v-list-tile v-for="article in date.articles.slice(1)" @click="goToArticle(article._url)" :key="article._id" avatar class="py-1 my-1">
                          <v-list-tile-avatar color="grey" tile>
                            <img v-if="article._image_url" :src="article._image_url">
                            <v-icon v-else dark>block</v-icon>
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title>{{article._title}}</v-list-tile-title>
                            <v-list-tile-title v-html="article._source" class="pointer caption"></v-list-tile-title>
                            <v-list-tile-sub-title
                              v-html="article._description"
                            ></v-list-tile-sub-title>
                          </v-list-tile-content>
                          <v-list-tile-avatar size="40" class="pointer pr-2">
                            <v-layout row class="align-center pointer accent--text caption">
                              <v-icon size="14" color="blue lighten-2">fab fa-twitter</v-icon><br>
                              <span width="100%">{{ formatNumber(article._tweeted_count) }}</span>
                            </v-layout>
                          </v-list-tile-avatar>
                          <v-list-tile-content class='counters align-center'>
                            <v-layout row class="align-center justify-content-center">
                              <v-flex width="66px">
                                <v-list-tile-sub-title>{{ formatEchartsDate(getLocalDate(article._date_published)) }}</v-list-tile-sub-title>
                                <v-list-tile-sub-title v-html="formatTime(getLocalDate(article._date_published))"></v-list-tile-sub-title>
                              </v-flex>
                            </v-layout>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="!(date.page.articleLastPage === true && date.page.articlePage === 1)">
                          <v-flex xs12>
                            <v-btn style="position: absolute; left: 5px;" outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToArticlePage('first', index)" :disabled="date.page.articlePage === 1">
                              <v-icon>first_page</v-icon>
                            </v-btn>
                            <v-btn outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToArticlePage('previous', index)" :disabled="date.page.articlePage === 1">
                              <v-icon>keyboard_arrow_left</v-icon>
                            </v-btn>
                            <v-btn class="elevation-1 noHover" style="cursor: auto" outline fab dark small color="accent lighten-2">
                              <span style="color: #727272">{{ date.page.articlePage }}</span>
                            </v-btn>
                            <v-btn class="elevation-1" outline fab dark small color="accent lighten-2" @click="goToArticlePage('next', index)" :disabled="date.page.articleLastPage">
                              <v-icon>keyboard_arrow_right</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-list-tile>
                      </v-list>
                    </v-expand-transition>
                  </v-list>
                </v-flex>
                <template v-if="date.articleDataState !== 'ready'">
                  <center class="alternateState">
                    <v-progress-circular
                      :size="70"
                      :width="7"
                      color="primary"
                      indeterminate
                    ></v-progress-circular>
                  </center>
                </template>
              </v-card>
              <v-card key="hashtag" class="my-2" v-if="(date.hashtags != undefined && date.hashtags.length > 0 && objectsExplored.indexOf('hashtag') !== -1)" >
                <v-flex :class="date.hashtagDataState !== 'ready' ? 'blurClass' : ''">
                  <v-card-title class="py-0">
                    <v-icon class="px-3">fas fa-hashtag</v-icon>
                    <span class="subheading px-2"> {{ formatNumber(date.hashtagCountHashtags) }} Hashtags </span>
                    <v-spacer></v-spacer>
                    <v-flex xs4>
                      <v-select v-model="date.hashtagSortBy" @input="sortHashtag(index)" :items="sortHashtags" single-line hint="Sort by" persistent-hint item-text="text" item-value="value" dense label="Sort by" :menu-props="{maxHeight:'900'}">
                        <template slot="selection" slot-scope="{ item }">
                          <span> {{item.text}} </span>
                        </template>
                        <template slot="item" slot-scope="{ item }">
                          <v-list-tile-content>
                            <v-list-tile-title v-text="item.text"></v-list-tile-title>
                          </v-list-tile-content>
                        </template>
                      </v-select>
                    </v-flex>
                    <v-btn icon @click="date.hashtag=!date.hashtag" :disabled="(date.page.hashtagLastPage === true && date.page.hashtagPage === 1 && date.hashtags.length === 1)">
                      <v-icon>{{!date.hashtag ? 'fas fa-angle-down' : 'fas fa-angle-up'}}</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-list two-lines class="scroll-y list-complete-enter" style="max-height: 400px;">
                    <v-list-tile avatar class="pa-0" @click="goToHashtag(date.hashtags[0]._tag)">
                      <v-list-tile-avatar tile>
                        <!-- <img v-if="date.hashtags[0]._image_url" :src="date.hashtags[0]._image_url">
                        <v-icon v-else dark>block</v-icon> -->
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>#{{ date.hashtags[0]._tag }}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-avatar size="40" class="pointer pr-2">
                        <v-layout row class="align-center pointer accent--text caption">
                          <v-icon size="14" color="blue lighten-2">fab fa-twitter</v-icon><br>
                          <span width="100%">{{ formatNumber(date.hashtags[0]._tweeted_count) }}</span>
                        </v-layout>
                      </v-list-tile-avatar>
                      <v-list-tile-content class='counters align-center'>
                        <v-layout row class="align-center justify-content-center">
                          <v-flex width="66px">
                            <v-list-tile-sub-title>{{ formatEchartsDate(getLocalDate(date.hashtags[0]._created_at)) }}</v-list-tile-sub-title>
                            <v-list-tile-sub-title v-html="formatTime(getLocalDate(date.hashtags[0]._created_at))"></v-list-tile-sub-title>
                          </v-flex>
                        </v-layout>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-expand-transition group v-if="date.hashtag">
                      <v-list>
                        <v-list-tile v-for="hashtag in date.hashtags.slice(1)" @click="goToHashtag(hashtag._tag)" :key="hashtag._id" avatar>
                          <v-list-tile-avatar tile>
                            <!-- <img v-if="hashtag._image_url" :src="hashtag._image_url">
                            <v-icon v-else dark>block</v-icon> -->
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title>#{{hashtag._tag}}</v-list-tile-title>
                          </v-list-tile-content>
                          <v-list-tile-avatar size="40" class="pointer pr-2">
                            <v-layout row class="align-center pointer accent--text caption">
                              <v-icon size="14" color="blue lighten-2">fab fa-twitter</v-icon><br>
                              <span width="100%">{{ formatNumber(hashtag._tweeted_count) }}</span>
                            </v-layout>
                          </v-list-tile-avatar>
                          <v-list-tile-content class='counters align-center'>
                            <v-layout row class="align-center justify-content-center">
                              <v-flex width="66px">
                                <v-list-tile-sub-title>{{ formatEchartsDate(getLocalDate(hashtag._created_at)) }}</v-list-tile-sub-title>
                                <v-list-tile-sub-title v-html="formatTime(getLocalDate(hashtag._created_at))"></v-list-tile-sub-title>
                              </v-flex>
                            </v-layout>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="!(date.page.hashtagLastPage === true && date.page.hashtagPage === 1)">
                          <v-flex xs12>
                            <v-btn style="position: absolute; left: 5px;" outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToHashtagPage('first', index)" :disabled="date.page.hashtagPage === 1">
                              <v-icon>first_page</v-icon>
                            </v-btn>
                            <v-btn outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToHashtagPage('previous', index)" :disabled="date.page.hashtagPage === 1">
                              <v-icon>keyboard_arrow_left</v-icon>
                            </v-btn>
                            <v-btn class="elevation-1 noHover" style="cursor: auto" outline fab dark small color="accent lighten-2">
                              <span style="color: #727272">{{ date.page.hashtagPage }}</span>
                            </v-btn>
                            <v-btn class="elevation-1" outline fab dark small color="accent lighten-2" @click="goToHashtagPage('next', index)" :disabled="date.page.hashtagLastPage">
                              <v-icon>keyboard_arrow_right</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-list-tile>
                      </v-list>
                    </v-expand-transition>
                  </v-list>
                </v-flex>
                <template v-if="date.hashtagDataState !== 'ready'">
                  <center class="alternateState">
                    <v-progress-circular
                      :size="70"
                      :width="7"
                      color="primary"
                      indeterminate
                    ></v-progress-circular>
                  </center>
                </template>
              </v-card>
              <v-card key="entity" class="my-2" v-if="(date.entities != undefined && date.entities.length > 0 && objectsExplored.indexOf('entity') !== -1)" >
                <v-flex :class="date.entityDataState !== 'ready' ? 'blurClass' : ''">
                  <v-card-title class="py-0">
                    <v-icon class="px-3">fas fa-tags</v-icon>
                    <span class="subheading px-2"> {{ formatNumber(date.entityCountEntities) }} Entities </span>
                    <v-spacer></v-spacer>
                    <v-flex xs4>
                      <v-select v-model="date.entitySortBy" @input="sortEntity(index)" :items="sortEntities" single-line hint="Sort by" persistent-hint item-text="text" item-value="value" dense label="Sort by" :menu-props="{maxHeight:'900'}">
                        <template slot="selection" slot-scope="{ item }">
                          <span> {{item.text}} </span>
                        </template>
                        <template slot="item" slot-scope="{ item }">
                          <v-list-tile-content>
                            <v-list-tile-title v-text="item.text"></v-list-tile-title>
                          </v-list-tile-content>
                        </template>
                      </v-select>
                    </v-flex>
                    <v-btn icon @click="date.entity=!date.entity" :disabled="(date.page.entityLastPage === true && date.page.entityPage === 1 && date.entities.length === 1)">
                      <v-icon>{{!date.entity ? 'fas fa-angle-down' : 'fas fa-angle-up'}}</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-list two-lines class="scroll-y list-complete-enter" style="max-height: 400px;">
                    <v-list-tile avatar class="pa-0">
                      <v-list-tile-avatar tile>
                        <!-- <img v-if="date.entities[0]._image_url" :src="date.entities[0]._image_url">
                        <v-icon v-else dark>block</v-icon> -->
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ date.entities[0]._name }}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-avatar size="40" class="pointer pr-2">
                        <v-layout row class="align-center pointer accent--text caption">
                          <v-icon size="14" color="blue lighten-2">fab fa-twitter</v-icon><br>
                          <span width="100%">{{ formatNumber(date.entities[0]._tweeted_count) }}</span>
                        </v-layout>
                      </v-list-tile-avatar>
                      <v-list-tile-content class='counters align-center'>
                        <v-layout row class="align-center justify-content-center">
                          <v-flex width="66px">
                            <v-list-tile-sub-title>{{ formatEchartsDate(getLocalDate(date.entities[0]._created_at)) }}</v-list-tile-sub-title>
                            <v-list-tile-sub-title v-html="formatTime(getLocalDate(date.entities[0]._created_at))"></v-list-tile-sub-title>
                          </v-flex>
                        </v-layout>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-expand-transition group v-if="date.entity">
                      <v-list>
                        <v-list-tile v-for="entity in date.entities.slice(1)" :key="entity._id" avatar>
                          <v-list-tile-avatar tile>
                            <!-- <img v-if="entity._image_url" :src="entity._image_url">
                            <v-icon v-else dark>block</v-icon> -->
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title>{{entity._name}}</v-list-tile-title>
                          </v-list-tile-content>
                          <v-list-tile-avatar size="40" class="pointer pr-2">
                            <v-layout row class="align-center pointer accent--text caption">
                              <v-icon size="14" color="blue lighten-2">fab fa-twitter</v-icon><br>
                              <span width="100%">{{ formatNumber(entity._tweeted_count) }}</span>
                            </v-layout>
                          </v-list-tile-avatar>
                          <v-list-tile-content class='counters align-center'>
                            <v-layout row class="align-center justify-content-center">
                              <v-flex width="66px">
                                <v-list-tile-sub-title>{{ formatEchartsDate(getLocalDate(entity._created_at)) }}</v-list-tile-sub-title>
                                <v-list-tile-sub-title v-html="formatTime(getLocalDate(entity._created_at))"></v-list-tile-sub-title>
                              </v-flex>
                            </v-layout>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="!(date.page.entityLastPage === true && date.page.entityPage === 1)">
                          <v-flex xs12>
                            <v-btn style="position: absolute; left: 5px;" outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToEntityPage('first', index)" :disabled="date.page.entityPage === 1">
                              <v-icon>first_page</v-icon>
                            </v-btn>
                            <v-btn outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToEntityPage('previous', index)" :disabled="date.page.entityPage === 1">
                              <v-icon>keyboard_arrow_left</v-icon>
                            </v-btn>
                            <v-btn class="elevation-1 noHover" style="cursor: auto" outline fab dark small color="accent lighten-2">
                              <span style="color: #727272">{{ date.page.entityPage }}</span>
                            </v-btn>
                            <v-btn class="elevation-1" outline fab dark small color="accent lighten-2" @click="goToEntityPage('next', index)" :disabled="date.page.entityLastPage">
                              <v-icon>keyboard_arrow_right</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-list-tile>
                      </v-list>
                    </v-expand-transition>
                  </v-list>
                </v-flex>
                <template v-if="date.entityDataState !== 'ready'">
                  <center class="alternateState">
                    <v-progress-circular
                      :size="70"
                      :width="7"
                      color="primary"
                      indeterminate
                    ></v-progress-circular>
                  </center>
                </template>
              </v-card>
              <v-card key="data" class="my-2" height="148px" v-if="!(date.tweets !== undefined && date.tweets.length > 0 && objectsExplored.indexOf('tweet') !== -1) && !(date.articles !== undefined && date.articles.length > 0 && objectsExplored.indexOf('article') !== -1) && !(date.hashtags !== undefined && date.hashtags.length > 0 && objectsExplored.indexOf('hashtag') !== -1) && !(date.entities !== undefined && date.entities.length > 0 && objectsExplored.indexOf('entity') !== -1)">
                <v-layout row align-center justify-space-around>
                  <v-flex xs12 order-lg2>
                    <template v-if="(date.articleDataState === 'loading' || date.tweetDataState === 'loading' || date.hashtagDataState === 'loading' || date.entityDataState === 'loading')">
                      <center class="alternateState">
                        <v-progress-circular
                          :size="70"
                          :width="7"
                          color="primary"
                          indeterminate
                        ></v-progress-circular>
                      </center>
                    </template>
                    <template v-else-if="date.articleDataState === 'error' || date.tweetDataState === 'error' || date.hashtagDataState === 'error' || date.entityDataState === 'error'">
                      <div class="d-flex py-4" style="flex-direction: column; align-items: center"><v-icon class="error--text" style="font-size: 40px !important">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
                    </template>
                    <template v-else>
                      <div class="d-flex py-4" style="flex-direction: column; align-items: center"><v-icon class="primary--text" style="font-size: 40px !important;width:100%">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">no data found</p></div>
                    </template>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-timeline-item>
          </v-scroll-y-transition>
          <v-btn @click="appendDates()" :loading="appendLoading === 'loading'" fab :disabled="(appendLoading === 'loading') || !(dates !== 'undefined' && dates.length > 0 && new Date(dates[dates.length - 1].date.toDate) < new Date(new Date(this.getFilters.toDate).setHours(24)))">
            <v-tooltip left>
              <span>Fronttrack</span>
              <v-icon slot="activator">fas fa-angle-down</v-icon>
            </v-tooltip>
          </v-btn>
        </v-timeline>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style scoped>
.pointer{
  cursor: pointer;
}
.alternateState{
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.blurClass{
  filter: blur(5px);
  -webkit-filter: blur(5px);
}
</style>
<style>
.counters {
  flex: none;
  min-width: 75px
}
.ascending {
  transform: rotate(-180deg);
  transition: 0.2s all ease-in-out;
}
.descending {
  transform: rotate(0deg);
  transition: 0.2s all ease-in-out;
}
</style>
<script>
import { mapGetters, mapMutations } from 'vuex'
import underscore from 'underscore'
import { snap } from '@/helpers/snapshots'
import axios from 'axios'
import numeral from 'numeral'
import Filters from './Filters.vue'
import { format } from 'date-fns'
import { formatEchartsDate, formatTime, getLocalDate, formatDateTime, formatTimeWithSeconds, getQueryFromDateTime } from '@/helpers/formatters'

export default {
  props: {
    id: 'String',
    type: 'String',
    filters: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      prependLoading: 'ready',
      appendLoading: 'ready',
      selectedConnections: ['reply', 'quote', 'retweet'],
      connections: [
        {
          text: 'Reply',
          value: 'reply'
        },
        {
          text: 'Quote',
          value: 'quote'
        },
        {
          text: 'Retweet',
          value: 'retweet'
        },
        {
          text: 'Entity',
          value: 'entity'
        },
        {
          text: 'Hashtag',
          value: 'hashtag'
        },
        {
          text: 'Article Story',
          value: 'story'
        }
      ],
      opposite: true,
      sortTweets: [
        {
          color: 'orange lighten-2',
          icon: 'fas fa-calendar',
          text: 'Latest First',
          value: {
            sort: '_created_at',
            order: 'DESC'
          }
        },
        {
          color: 'orange lighten-2',
          icon: 'fas fa-calendar',
          text: 'Oldest First',
          value: {
            sort: '_created_at',
            order: 'ASC'
          }
        },
        {
          color: 'green lighten-2',
          icon: 'fas fa-retweet',
          text: 'Most Retweets',
          value: {
            sort: '_retweet_count',
            order: 'DESC'
          }
        },
        {
          color: 'green lighten-2',
          icon: 'fas fa-retweet',
          text: 'Least Retweets',
          value: {
            sort: '_retweet_count',
            order: 'ASC'
          }
        }
      ],
      sortArticles: [
        {
          color: 'orange lighten-2',
          icon: 'fas fa-calendar',
          text: 'Latest First',
          value: {
            sort: '_date_published',
            order: 'DESC'
          }
        },
        {
          color: 'orange lighten-2',
          icon: 'fas fa-calendar',
          text: 'Oldest First',
          value: {
            sort: '_date_published',
            order: 'ASC'
          }
        },
        {
          color: 'blue lighten-2',
          icon: 'fab fa-twitter',
          text: 'Most Tweeted',
          value: {
            sort: '_tweeted_count',
            order: 'DESC'
          }
        },
        {
          color: 'blue lighten-2',
          icon: 'fab fa-twitter',
          text: 'Least Tweeted',
          value: {
            sort: '_tweeted_count',
            order: 'ASC'
          }
        }
      ],
      sortHashtags: [
        {
          color: 'orange lighten-2',
          icon: 'fas fa-calendar',
          text: 'Latest First',
          value: {
            sort: '_created_at',
            order: 'DESC'
          }
        },
        {
          color: 'orange lighten-2',
          icon: 'fas fa-calendar',
          text: 'Oldest First',
          value: {
            sort: '_created_at',
            order: 'ASC'
          }
        },
        {
          color: 'blue lighten-2',
          icon: 'fab fa-twitter',
          text: 'Most Tweeted',
          value: {
            sort: '_tweeted_count',
            order: 'DESC'
          }
        },
        {
          color: 'blue lighten-2',
          icon: 'fab fa-twitter',
          text: 'Least Tweeted',
          value: {
            sort: '_tweeted_count',
            order: 'ASC'
          }
        }
      ],
      sortEntities: [
        {
          color: 'orange lighten-2',
          icon: 'fas fa-calendar',
          text: 'Latest First',
          value: {
            sort: '_created_at',
            order: 'DESC'
          }
        },
        {
          color: 'orange lighten-2',
          icon: 'fas fa-calendar',
          text: 'Oldest First',
          value: {
            sort: '_created_at',
            order: 'ASC'
          }
        },
        {
          color: 'blue lighten-2',
          icon: 'fab fa-twitter',
          text: 'Most Tweeted',
          value: {
            sort: '_tweeted_count',
            order: 'DESC'
          }
        },
        {
          color: 'blue lighten-2',
          icon: 'fab fa-twitter',
          text: 'Least Tweeted',
          value: {
            sort: '_tweeted_count',
            order: 'ASC'
          }
        }
      ],
      interval: {
        text: 'Day',
        value: 'daily'
      },
      timeInterval: [
        {
          text: 'Hour',
          value: 'hourly'
        },
        {
          text: 'Day',
          value: 'daily'
        },
        {
          text: 'Week',
          value: 'weekly'
        },
        {
          text: 'Month',
          value: 'monthly'
        }
      ],
      objectsExplored: ['tweet'],
      dates: [],
      initialTweetId: null,
      initialTweetDate: null
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters('toggles', ['getFiltersChips']),
    ...mapGetters('filters', ['getFilters', 'getQueryExcluding', 'getQuery']),
    getObjectId: function () {
      return this.$route.query.id
    },
    getObjectType: function () {
      return this.$route.query.type + 'Id'
    },
    getObjectFrom: function () {
      return this.$route.query.type ? 'From' + this.$route.query.type[0].toUpperCase() + this.$route.query.type.slice(1) : null
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setFilters', 'resetFilters']),
    formatEchartsDate: formatEchartsDate,
    formatTime: formatTime,
    formatDateTime: formatDateTime,
    getLocalDate: getLocalDate,
    snap,
    formatNumber: function (value) {
      return Number(value) > 999 ? numeral(Number(value)).format('0.0a').toUpperCase() : value
    },
    goToHashtag (tag) {
      window.open('https://twitter.com/hashtag/' + tag + '?src=hash', '_blank')
    },
    goToArticle (url) {
      window.open(url, '_blank')
    },
    goToUser (name) {
      window.open('https://twitter.com/' + name, '_blank')
    },
    goToTweet (id, name) {
      window.open('https://twitter.com/' + name + '/status/' + id, '_blank')
    },
    hideNoData: function (date, index) {
      let noData = !(date.tweets !== undefined && date.tweets.length > 0 && this.objectsExplored.indexOf('tweet') !== -1) && !(date.articles !== undefined && date.articles.length > 0 && this.objectsExplored.indexOf('article') !== -1) && !(date.hashtags !== undefined && date.hashtags.length > 0 && this.objectsExplored.indexOf('hashtag') !== -1) && !(date.entities !== undefined && date.entities.length > 0 && this.objectsExplored.indexOf('entity') !== -1)
      let noData1 = false
      let noData2 = false
      let direction = -1
      if (typeof this.dates[index + direction] !== 'undefined') {
        noData1 = !(this.dates[index + direction].tweets !== undefined && this.dates[index + direction].tweets.length > 0 && this.objectsExplored.indexOf('tweet') !== -1) && !(this.dates[index + direction].articles !== undefined && this.dates[index + direction].articles.length > 0 && this.objectsExplored.indexOf('article') !== -1) && !(this.dates[index + direction].hashtags !== undefined && this.dates[index + direction].hashtags.length > 0 && this.objectsExplored.indexOf('hashtag') !== -1) && !(this.dates[index + direction].entities !== undefined && this.dates[index + direction].entities.length > 0 && this.objectsExplored.indexOf('entity') !== -1)
      }
      direction = +1
      if (typeof this.dates[index + direction] !== 'undefined') {
        noData2 = !(this.dates[index + direction].tweets !== undefined && this.dates[index + direction].tweets.length > 0 && this.objectsExplored.indexOf('tweet') !== -1) && !(this.dates[index + direction].articles !== undefined && this.dates[index + direction].articles.length > 0 && this.objectsExplored.indexOf('article') !== -1) && !(this.dates[index + direction].hashtags !== undefined && this.dates[index + direction].hashtags.length > 0 && this.objectsExplored.indexOf('hashtag') !== -1) && !(this.dates[index + direction].entities !== undefined && this.dates[index + direction].entities.length > 0 && this.objectsExplored.indexOf('entity') !== -1)
      }
      return !(noData && noData1 && noData2)
    },
    alternateImg: function (index, i) {
      this.dates[index].tweets[i]._user_profile_image_url_https = 'https://abs.twimg.com/sticky/default_profile_images/default_profile.png'
    },
    toggleObjects () {
      if (this.initialTweetId || this.$route.query.id || this.dates.length > 0) {
        this.dates.forEach((date, index) => {
          this.getData(date.date.fromDate, date.date.toDate, index, 1)
        })
      }
    },
    intervalText (fromDate, toDate) {
      if (this.interval.value === 'hourly') {
        return this.formatDateTime(fromDate) + ' - ' + this.formatDateTime(toDate)
      } else if (this.interval.value === 'daily') {
        return fromDate.toDateString() + ' - ' + toDate.toDateString()
      } else if (this.interval.value === 'weekly') {
        return fromDate.toDateString() + ' - ' + toDate.toDateString()
      } else if (this.interval.value === 'monthly') {
        return fromDate.toDateString() + ' - ' + toDate.toDateString()
      }
    },
    getInterval (date, direction) {
      let newDate = date
      if (this.interval.value === 'hourly') {
        newDate = new Date(new Date(date).setUTCHours(new Date(date).getUTCHours() + (1 * direction)))
      } else if (this.interval.value === 'daily') {
        newDate = new Date(new Date(date).setUTCDate(new Date(date).getUTCDate() + (1 * direction)))
      } else if (this.interval.value === 'weekly') {
        newDate = new Date(new Date(date).setUTCDate(new Date(date).getUTCDate() + (7 * direction)))
      } else if (this.interval.value === 'monthly') {
        newDate = new Date(new Date(date).setUTCMonth(new Date(date).getUTCMonth() + (1 * direction)))
      }
      // if (direction === -1) {
      //   if (new Date(new Date(this.getFilters.fromDate).setHours(0)) > newDate) {
      //     return new Date(new Date(this.getFilters.fromDate).setHours(0))
      //   }
      // } else {
      //   if (new Date(new Date(this.getFilters.toDate).setHours(23)) < newDate) {
      //     return new Date(new Date(this.getFilters.toDate).setHours(23))
      //   }
      // }
      return newDate
    },
    async changeInterval () {
      let fromDate = new Date(this.getFilters.fromDate)
      let toDate = new Date(fromDate)
      if (this.$route.query.date) {
        toDate = new Date(this.$route.query.date)
        fromDate = new Date(toDate)
      } else if (this.initialTweetDate) {
        toDate = new Date(this.initialTweetDate)
        fromDate = new Date(toDate)
      }
      toDate = new Date(toDate.setMinutes(0))
      toDate = new Date(toDate.setSeconds(0))
      if (this.interval.value !== 'hourly') {
        toDate = new Date(toDate.setHours(0))
      }
      fromDate = new Date(toDate)
      if (fromDate < new Date(new Date(this.getFilters.fromDate).setHours(0))) {
        fromDate = new Date(new Date(this.getFilters.fromDate).setHours(0))
      }
      if (this.interval.value === 'hourly') {
        fromDate.setTime(toDate.getTime())
        toDate = new Date(toDate.setHours(toDate.getHours() + 1))
      } else if (this.interval.value === 'daily') {
        toDate = new Date(toDate.setDate(toDate.getDate() + 1))
      } else if (this.interval.value === 'weekly') {
        toDate = new Date(toDate.setDate(toDate.getDate() + 7))
      } else if (this.interval.value === 'monthly') {
        toDate = new Date(toDate.setMonth(toDate.getMonth() + 1))
      }
      if (toDate > new Date(new Date(this.getFilters.toDate).setHours(24))) {
        toDate = new Date(new Date(this.getFilters.toDate).setHours(24))
      }
      let date = [
        {
          id: 0,
          date: {
            fromDate: fromDate,
            toDate: toDate
          },
          article: false,
          tweet: false,
          hashtag: false,
          entity: false,
          tweetSortBy: {
            sort: '_created_at',
            order: 'ASC'
          },
          articleSortBy: {
            sort: '_date_published',
            order: 'ASC'
          },
          hashtagSortBy: {
            sort: '_created_at',
            order: 'ASC'
          },
          entitySortBy: {
            sort: '_created_at',
            order: 'ASC'
          },
          page: {
            articlePage: 1,
            articleLastPage: false,
            tweetPage: 1,
            tweetLastPage: false,
            hashtagPage: 1,
            hashtagLastPage: false,
            entityPage: 1,
            entityLastPage: false
          }
        }
      ]
      if (this.objectsExplored.indexOf('tweet') !== -1) {
        date[0].tweets = []
      }
      if (this.objectsExplored.indexOf('article') !== -1) {
        date[0].articles = []
      }
      if (this.objectsExplored.indexOf('hashtag') !== -1) {
        date[0].hashtags = []
      }
      if (this.objectsExplored.indexOf('entity') !== -1) {
        date[0].entities = []
      }
      this.dates = date
      await this.getData(fromDate, toDate, this.dates.length - 1, 1)
    },
    goToTweetPage (direction, id) {
      this.dates[id].tweetPageDataState = 'loading'
      var newPage = this.dates[id].page.tweetPage <= 0 ? 1 : this.dates[id].page.tweetPage
      if (direction === 'first') {
        newPage = 1
      } else if (direction === 'previous') {
        newPage--
      } else if (direction === 'next') {
        newPage++
      }
      if (newPage !== this.dates[id].page.tweetPage) {
        this.dates[id].page.tweetPage = newPage
        this.getTweets(this.dates[id].date.fromDate, this.dates[id].date.toDate, id, newPage)
        if (!this.dates[id].hasOwnProperty('tweets')) {
          this.dates[id].tweets = []
        }
      }
      this.dates[id].tweetPageDataState = 'ready'
    },
    goToArticlePage (direction, id) {
      this.dates[id].articlePageDataState = 'loading'
      var newPage = this.dates[id].page.articlePage <= 0 ? 1 : this.dates[id].page.articlePage
      if (direction === 'first') {
        newPage = 1
      } else if (direction === 'previous') {
        newPage--
      } else if (direction === 'next') {
        newPage++
      }
      if (newPage !== this.dates[id].page.articlePage) {
        this.dates[id].page.articlePage = newPage
        this.getArticles(this.dates[id].date.fromDate, this.dates[id].date.toDate, id, newPage)
        if (!this.dates[id].hasOwnProperty('articles')) {
          this.dates[id].articles = []
        }
      }
      this.dates[id].articlePageDataState = 'ready'
    },
    goToHashtagPage (direction, id) {
      this.dates[id].hashtagPageDataState = 'loading'
      var newPage = this.dates[id].page.hashtagPage <= 0 ? 1 : this.dates[id].page.hashtagPage
      if (direction === 'first') {
        newPage = 1
      } else if (direction === 'previous') {
        newPage--
      } else if (direction === 'next') {
        newPage++
      }
      if (newPage !== this.dates[id].page.hashtagPage) {
        this.dates[id].page.hashtagPage = newPage
        this.getHashtags(this.dates[id].date.fromDate, this.dates[id].date.toDate, id, newPage)
        if (!this.dates[id].hasOwnProperty('hashtags')) {
          this.dates[id].hashtags = []
        }
      }
      this.dates[id].hashtagPageDataState = 'ready'
    },
    goToEntityPage (direction, id) {
      this.dates[id].entitiyPageDataState = 'loading'
      var newPage = this.dates[id].page.entitiyPage <= 0 ? 1 : this.dates[id].page.entitiyPage
      if (direction === 'first') {
        newPage = 1
      } else if (direction === 'previous') {
        newPage--
      } else if (direction === 'next') {
        newPage++
      }
      if (newPage !== this.dates[id].page.entitiyPage) {
        this.dates[id].page.entitiyPage = newPage
        this.getEntities(this.dates[id].date.fromDate, this.dates[id].date.toDate, id, newPage)
        if (!this.dates[id].hasOwnProperty('entities')) {
          this.dates[id].entities = []
        }
      }
      this.dates[id].entitiyPageDataState = 'ready'
    },
    sortTweet (id) {
      this.dates[id].tweetPageDataState = 'loading'
      this.getTweets(this.dates[id].date.fromDate, this.dates[id].date.toDate, id, 1)
      this.dates[id].tweetPageDataState = 'ready'
    },
    sortArticle (id) {
      this.dates[id].articlePageDataState = 'loading'
      this.getArticles(this.dates[id].date.fromDate, this.dates[id].date.toDate, id, 1)
      this.dates[id].articlePageDataState = 'ready'
    },
    sortHashtag (id) {
      this.dates[id].hashtagPageDataState = 'loading'
      this.getHashtags(this.dates[id].date.fromDate, this.dates[id].date.toDate, id, 1)
      this.dates[id].hashtagPageDataState = 'ready'
    },
    sortEntity (id) {
      this.dates[id].entityPageDataState = 'loading'
      this.getEntities(this.dates[id].date.fromDate, this.dates[id].date.toDate, id, 1)
      this.dates[id].entityPageDataState = 'ready'
    },
    timelineItemPosition (index) {
      if (!this.opposite) {
        return index % 2 === 0
      } else {
        return index % 2 !== 0
      }
    },
    async getData (fromDate, toDate, id, page) {
      let promises = []
      if (this.objectsExplored.indexOf('tweet') !== -1) {
        promises.push(this.getTweets(fromDate, toDate, id, page))
      }
      if (this.objectsExplored.indexOf('article') !== -1) {
        promises.push(this.getArticles(fromDate, toDate, id, page))
      }
      if (this.objectsExplored.indexOf('hashtag') !== -1) {
        promises.push(this.getHashtags(fromDate, toDate, id, page))
      }
      if (this.objectsExplored.indexOf('entity') !== -1) {
        promises.push(this.getEntities(fromDate, toDate, id, page))
      }
      return Promise.all(promises).then(function (data) {
        let x = false
        data.forEach(function (response) {
          x = x || response
        })
        return x
      })
    },
    async getArticles (fromDate, toDate, id, page) {
      let fromTimeArray = formatTimeWithSeconds(new Date(Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), fromDate.getHours(), fromDate.getMinutes()))).split(':')
      let toTimeArray = formatTimeWithSeconds(new Date(Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), toDate.getHours(), toDate.getMinutes()))).split(':')
      this.dates[id].articleDataState = 'loading'
      this.dates[id].page.articlePage = page
      this.dates[id].page.articleLastPage = false
      let sortBy = this.dates[id].articleSortBy.sort
      let orderBy = this.dates[id].articleSortBy.order
      let query = {connections: this.selectedConnections, intervalFromDate: getQueryFromDateTime(format(new Date(Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), fromDate.getHours(), fromDate.getMinutes())), 'YYYY-MM-DD'), fromTimeArray[0], fromTimeArray[1], fromTimeArray[2]), intervalToDate: getQueryFromDateTime(format(new Date(Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), toDate.getHours(), toDate.getMinutes())), 'YYYY-MM-DD'), toTimeArray[0], toTimeArray[1], toTimeArray[2]), sortBy: sortBy, order: orderBy, pageSize: 15, pageNumber: page}
      let backtrackCall = 'getArticlesBacktracker' + (this.getObjectFrom ? this.getObjectFrom : 'FromTweet')
      if (this.getObjectFrom === null) {
        query['tweetId'] = this.initialTweetId
      } else {
        query[this.getObjectType] = this.getObjectId
      }
      return axios.all([this.$store.dispatch(backtrackCall, this.getQueryExcluding(query)), this.$store.dispatch(backtrackCall + 'Count', this.getQueryExcluding(query))])
      .then(axios.spread((r1, r2) => {
        if (r1.data.status === 'SUCCESS' && r2.data.status === 'SUCCESS') {
          this.dates[id].articles = r1.data.payload
          if (r2.data.payload.length > 0) {
            this.dates[id].articleCountArticles = r2.data.payload[0]['_article_count']
          }
          if (r1.data.payload.length > 0) {
            this.dates[id].articleDataState = 'ready'
            this.dates[id].page.articleLastPage = (r1.data.payload.length < 15)
          } else {
            this.dates[id].articles = []
            this.dates[id].articleDataState = 'noData'
            this.dates[id].page.articleLastPage = true
          }
        } else {
          this.dates[id].articleDataState = 'error'
          this.dates[id].page.articleLastPage = true
          this.notify({
            message: 'Something went wrong while fetching data.',
            show: true
          })
        }
        return this.dates[id].articleDataState === 'ready'
      }))
      .catch(err => {
        this.dates[id].articleDataState = 'error'
        this.notify({
          message: 'Something went wrong while connecting to the server.',
          show: true
        })
        console.log(err)
      })
    },
    async getTweets (fromDate, toDate, id, page) {
      let fromTimeArray = formatTimeWithSeconds(new Date(Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), fromDate.getHours(), fromDate.getMinutes()))).split(':')
      let toTimeArray = formatTimeWithSeconds(new Date(Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), toDate.getHours(), toDate.getMinutes()))).split(':')
      this.dates[id].tweetDataState = 'loading'
      this.dates[id].page.tweetPage = page
      this.dates[id].page.tweetLastPage = false
      let sortBy = this.dates[id].tweetSortBy.sort
      let orderBy = this.dates[id].tweetSortBy.order
      let query = {connections: this.selectedConnections, intervalFromDate: getQueryFromDateTime(format(new Date(Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), fromDate.getHours(), fromDate.getMinutes())), 'YYYY-MM-DD'), fromTimeArray[0], fromTimeArray[1], fromTimeArray[2]), intervalToDate: getQueryFromDateTime(format(new Date(Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), toDate.getHours(), toDate.getMinutes())), 'YYYY-MM-DD'), toTimeArray[0], toTimeArray[1], toTimeArray[2]), sortBy: sortBy, order: orderBy, pageSize: 15, pageNumber: page}
      let backtrackCall = 'getTweetsBacktracker' + (this.getObjectFrom ? this.getObjectFrom : 'FromTweet')
      if (this.getObjectFrom === null) {
        query['tweetId'] = this.initialTweetId
      } else {
        query[this.getObjectType] = this.getObjectId
      }
      return axios.all([this.$store.dispatch(backtrackCall, this.getQueryExcluding(query)), this.$store.dispatch(backtrackCall + 'Count', this.getQueryExcluding(query))])
        .then(axios.spread((r1, r2) => {
          if (r1.data.status === 'SUCCESS' && r2.data.status === 'SUCCESS') {
            this.dates[id].tweets = r1.data.payload
            if (r2.data.payload.length > 0) {
              this.dates[id].tweetCountTweets = r2.data.payload[0]['_tweet_count']
            }
            if (r1.data.payload.length > 0) {
              this.dates[id].tweetDataState = 'ready'
              this.dates[id].page.tweetLastPage = (r1.data.payload.length < 15)
            } else {
              this.dates[id].tweets = []
              this.dates[id].tweetDataState = 'noData'
              this.dates[id].page.tweetLastPage = true
            }
          } else {
            this.dates[id].tweetDataState = 'error'
            this.dates[id].page.tweetLastPage = true
            this.notify({
              message: 'Something went wrong while fetching data.',
              show: true
            })
          }
          return this.dates[id].tweetDataState === 'ready'
        })
      )
      .catch(err => {
        this.dates[id].tweetDataState = 'error'
        this.notify({
          message: 'Something went wrong while connecting to the server.',
          show: true
        })
        console.log(err)
      })
    },
    async getHashtags (fromDate, toDate, id, page) {
      let fromTimeArray = formatTimeWithSeconds(new Date(Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), fromDate.getHours(), fromDate.getMinutes()))).split(':')
      let toTimeArray = formatTimeWithSeconds(new Date(Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), toDate.getHours(), toDate.getMinutes()))).split(':')
      this.dates[id].hashtagDataState = 'loading'
      this.dates[id].page.hashtagPage = page
      this.dates[id].page.hashtagLastPage = false
      let sortBy = this.dates[id].hashtagSortBy.sort
      let orderBy = this.dates[id].hashtagSortBy.order
      let query = {connections: this.selectedConnections, intervalFromDate: getQueryFromDateTime(format(new Date(Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), fromDate.getHours(), fromDate.getMinutes())), 'YYYY-MM-DD'), fromTimeArray[0], fromTimeArray[1], fromTimeArray[2]), intervalToDate: getQueryFromDateTime(format(new Date(Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), toDate.getHours(), toDate.getMinutes())), 'YYYY-MM-DD'), toTimeArray[0], toTimeArray[1], toTimeArray[2]), sortBy: sortBy, order: orderBy, pageSize: 15, pageNumber: page}
      let backtrackCall = 'getHashtagsBacktracker' + (this.getObjectFrom ? this.getObjectFrom : 'FromTweet')
      if (this.getObjectFrom === null) {
        query['tweetId'] = this.initialTweetId
      } else {
        query[this.getObjectType] = this.getObjectId
      }
      return axios.all([this.$store.dispatch(backtrackCall, this.getQueryExcluding(query)), this.$store.dispatch(backtrackCall + 'Count', this.getQueryExcluding(query))])
        .then(axios.spread((r1, r2) => {
          if (r1.data.status === 'SUCCESS' && r2.data.status === 'SUCCESS') {
            this.dates[id].hashtags = r1.data.payload
            if (r2.data.payload) {
              this.dates[id].hashtagCountHashtags = r2.data.payload[0]['_hashtag_count']
            }
            if (r1.data.payload.length > 0) {
              this.dates[id].hashtagDataState = 'ready'
              this.dates[id].page.hashtagLastPage = (r1.data.payload.length < 15)
            } else {
              this.dates[id].hashtags = []
              this.dates[id].hashtagDataState = 'noData'
              this.dates[id].page.hashtagLastPage = true
            }
          } else {
            this.dates[id].hashtagDataState = 'error'
            this.dates[id].page.hashtagLastPage = true
            this.notify({
              message: 'Something went wrong while fetching data.',
              show: true
            })
          }
          return this.dates[id].hashtagDataState === 'ready'
        })
      )
      .catch(err => {
        this.dates[id].hashtagDataState = 'error'
        this.notify({
          message: 'Something went wrong while connecting to the server.',
          show: true
        })
        console.log(err)
      })
    },
    async getEntities (fromDate, toDate, id, page) {
      let fromTimeArray = formatTimeWithSeconds(new Date(Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), fromDate.getHours(), fromDate.getMinutes()))).split(':')
      let toTimeArray = formatTimeWithSeconds(new Date(Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), toDate.getHours(), toDate.getMinutes()))).split(':')
      this.dates[id].entityDataState = 'loading'
      this.dates[id].page.entityPage = page
      this.dates[id].page.entityLastPage = false
      let sortBy = this.dates[id].entitySortBy.sort
      let orderBy = this.dates[id].entitySortBy.order
      let query = {connections: this.selectedConnections, intervalFromDate: getQueryFromDateTime(format(new Date(Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), fromDate.getHours(), fromDate.getMinutes())), 'YYYY-MM-DD'), fromTimeArray[0], fromTimeArray[1], fromTimeArray[2]), intervalToDate: getQueryFromDateTime(format(new Date(Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), toDate.getHours(), toDate.getMinutes())), 'YYYY-MM-DD'), toTimeArray[0], toTimeArray[1], toTimeArray[2]), sortBy: sortBy, order: orderBy, pageSize: 15, pageNumber: page}
      let backtrackCall = 'getEntitiesBacktracker' + (this.getObjectFrom ? this.getObjectFrom : 'FromTweet')
      if (this.getObjectFrom === null) {
        query['tweetId'] = this.initialTweetId
      } else {
        query[this.getObjectType] = this.getObjectId
      }
      return axios.all([this.$store.dispatch(backtrackCall, this.getQueryExcluding(query)), this.$store.dispatch(backtrackCall + 'Count', this.getQueryExcluding(query))])
        .then(axios.spread((r1, r2) => {
          if (r1.data.status === 'SUCCESS' && r2.data.status === 'SUCCESS') {
            this.dates[id].entities = r1.data.payload
            if (r2.data.payload.length > 0) {
              this.dates[id].entityCountEntities = r2.data.payload[0]['_entity_count']
            }
            if (r1.data.payload.length > 0) {
              this.dates[id].entityDataState = 'ready'
              this.dates[id].page.entityLastPage = (r1.data.payload.length < 15)
            } else {
              this.dates[id].entities = []
              this.dates[id].entityDataState = 'noData'
              this.dates[id].page.entityLastPage = true
            }
          } else {
            this.dates[id].entityDataState = 'error'
            this.dates[id].page.entityLastPage = true
            this.notify({
              message: 'Something went wrong while fetching data.',
              show: true
            })
          }
          return this.dates[id].hashtagDataState === 'ready'
        })
      )
      .catch(err => {
        this.dates[id].entityDataState = 'error'
        this.notify({
          message: 'Something went wrong while connecting to the server.',
          show: true
        })
        console.log(err)
      })
    },
    async prependDates () {
      this.prependLoading = 'loading'
      this.opposite = !this.opposite
      let toDate = new Date(this.dates[0].date.fromDate)
      let fromDate = this.getInterval(toDate, -1)
      let date = {
        date: {
          fromDate: fromDate,
          toDate: toDate
        },
        article: false,
        tweet: false,
        hashtag: false,
        entity: false,
        tweetSortBy: {
          sort: '_created_at',
          order: 'ASC'
        },
        articleSortBy: {
          sort: '_date_published',
          order: 'ASC'
        },
        hashtagSortBy: {
          sort: '_created_at',
          order: 'ASC'
        },
        entitySortBy: {
          sort: '_created_at',
          order: 'ASC'
        },
        page: {
          articlePage: 1,
          articleLastPage: false,
          tweetPage: 1,
          tweetLastPage: false,
          hashtagPage: 1,
          hashtagLastPage: false,
          entityPage: 1,
          entityLastPage: false
        },
        id: this.dates[0].id - 1
      }
      if (this.objectsExplored.indexOf('tweet') !== -1) {
        date.tweets = []
      }
      if (this.objectsExplored.indexOf('article') !== -1) {
        date.articles = []
      }
      if (this.objectsExplored.indexOf('hashtag') !== -1) {
        date.hashtags = []
      }
      if (this.objectsExplored.indexOf('entity') !== -1) {
        date.entities = []
      }
      this.dates.splice(0, 0, date)
      let data = await this.getData(fromDate, toDate, 0, 1)
      let n = 1
      while ((new Date(fromDate) > new Date(new Date(this.getFilters.fromDate).setHours(0)) && !data)) {
        for (let i = 1; i <= n * 2; i++) {
          fromDate = this.getInterval(fromDate, -1)
        }
        if (new Date(fromDate) <= new Date(this.getFilters.fromDate)) {
          fromDate = new Date(new Date(this.getFilters.fromDate).setHours(0))
        }
        n = n * 2
        data = await this.getData(fromDate, toDate, 0, 1)
        this.dates[0].date = {fromDate: fromDate, toDate: toDate}
      }
      this.prependLoading = 'ready'
    },
    async appendDates () {
      this.appendLoading = 'loading'
      let fromDate = new Date(this.dates[this.dates.length - 1].date.toDate)
      let toDate = this.getInterval(fromDate, 1)
      let date = {
        date: {
          fromDate: new Date(fromDate),
          toDate: new Date(toDate)
        },
        article: false,
        tweet: false,
        hashtag: false,
        entity: false,
        tweetSortBy: {
          sort: '_created_at',
          order: 'ASC'
        },
        articleSortBy: {
          sort: '_date_published',
          order: 'ASC'
        },
        hashtagSortBy: {
          sort: '_created_at',
          order: 'ASC'
        },
        entitySortBy: {
          sort: '_created_at',
          order: 'ASC'
        },
        page: {
          articlePage: 1,
          articleLastPage: false,
          tweetPage: 1,
          tweetLastPage: false,
          hashtagPage: 1,
          hashtagLastPage: false,
          entityPage: 1,
          entityLastPage: false
        },
        id: this.dates[this.dates.length - 1].id + 1
      }
      if (this.objectsExplored.indexOf('tweet') !== -1) {
        date.tweets = []
      }
      if (this.objectsExplored.indexOf('article') !== -1) {
        date.articles = []
      }
      if (this.objectsExplored.indexOf('hashtag') !== -1) {
        date.hashtags = []
      }
      if (this.objectsExplored.indexOf('entity') !== -1) {
        date.entities = []
      }
      this.dates.push(date)
      let data = await this.getData(fromDate, toDate, this.dates.length - 1, 1)
      let n = 1
      while ((new Date(toDate) < new Date(new Date(this.getFilters.toDate).setHours(24)) && !data)) {
        for (let i = 1; i <= n * 2; i++) {
          toDate = this.getInterval(toDate, 1)
        }
        if (new Date(toDate) >= new Date(new Date(this.getFilters.toDate).setHours(24))) {
          toDate = new Date(new Date(this.getFilters.toDate).setHours(24))
        }
        n = n * 2
        data = await this.getData(fromDate, toDate, this.dates.length - 1, 1)
        this.dates[this.dates.length - 1].date = {fromDate: fromDate, toDate: toDate}
      }
      this.appendLoading = 'ready'
    }
  },
  components: {
    Filters
  },
  watch: {
    getFilters: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (oldVal && newVal && !underscore.isEqual(newVal, oldVal) && this.getFilters.dirty === false) {
          if (this.$route.query.type === null || this.$route.query.type === undefined) {
            this.dates = []
            axios.all([this.$store.dispatch('getTweets', this.getQuery({sortBy: '_retweet_count', order: 'desc', pageSize: 1}))]).then(
              axios.spread(r1 => {
                if (r1.data.status === 'SUCCESS') {
                  if (r1.data.payload.length > 0) {
                    this.initialTweetId = r1.data.payload[0]['_tweet_id']
                    this.initialTweetDate = new Date(r1.data.payload[0]['_created_at'])
                    this.changeInterval()
                  } else {
                    this.initialTweetId = null
                  }
                } else {
                  this.initialTweetId = null
                }
              })
            )
            .catch(err => {
              this.initialTweetId = null
              console.log(err)
            })
          } else {
            this.changeInterval()
          }
        }
      }
    }
  },
  mounted: function () {
    if (this.$route.query.connections !== undefined) {
      this.selectedConnections = [].concat(this.$route.query.connections)
    }
    if (this.$route.query.objects !== undefined) {
      this.objectsExplored = [].concat(this.$route.query.objects)
    }
    if (this.$route.query.type === undefined || this.$route.query.type === undefined) {
      axios.all([this.$store.dispatch('getTweets', this.getQuery({sortBy: '_retweet_count', order: 'desc', pageSize: 1}))]).then(
        axios.spread(r1 => {
          if (r1.data.status === 'SUCCESS') {
            if (r1.data.payload.length > 0) {
              this.initialTweetId = r1.data.payload[0]['_tweet_id']
              this.initialTweetDate = new Date(r1.data.payload[0]['_created_at'])
              this.changeInterval()
            } else {
              this.initialTweetId = null
            }
          } else {
            this.initialTweetId = null
          }
        })
      )
      .catch(err => {
        this.initialTweetId = null
        console.log(err)
      })
    } else {
      this.changeInterval()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Backtracker.vue